/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";
import { useNewsletterContext } from "../../../../context/newsletter/NewsletterContext";
import { Search, Pagination, MyActionButton } from "../../component/Component";
import NewsletterModal from "./NewsletterModal";

const Overview = () => {
  const [newsletterList, setNewsletterList] = useState([]);
  const { newsletter, fetchNewsletter, sendNotification, count } =
    useNewsletterContext();

  const [page, setPage] = useState(1);

  const [contentTitle, setContentTitle] = useState("");
  const [dataIds, setDataIds] = useState([]);

  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!newsletter) fetchNewsletter(page, pageSize);
    else setNewsletterList(newsletter);
  }, [newsletter, newsletterList]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (newsletter !== null && newsletter !== undefined)
      newsletter.map((_newsletter_) => {
        if (_newsletter_.email.toString().toLowerCase().includes(key))
          return searchArray.push(_newsletter_);
        return true;
      });

    setNewsletterList(searchArray);
    if (key === "") setNewsletterList(newsletter);
  };

  const sendDailyDigest = async () => {
    setLoading(true);

    const data = {
      eventIds: contentTitle === "Event" ? dataIds : [],
      attractionIds: contentTitle === "Attraction" ? dataIds : [],
      partyIds: contentTitle === "Party" ? dataIds : [],
      restaurantIds: contentTitle === "Restaurant" ? dataIds : [],
      nightLifeIds: contentTitle === "Nightlife" ? dataIds : [],
      musicIds: contentTitle === "Music" ? dataIds : [],
      safariIds: contentTitle === "Safari" ? dataIds : [],
      cityGuideIds: contentTitle === "City Guide" ? dataIds : [],
      tourPackageIds: contentTitle === "Tour Package" ? dataIds : [],
      hotelIds: contentTitle === "Hotel" ? dataIds : [],
      classIds: contentTitle === "Classes" ? dataIds : [],
      museumIds: contentTitle === "Museum" ? dataIds : [],
      shoppingIds: contentTitle === "Shopping" ? dataIds : [],
      foodIds: contentTitle === "Food" ? dataIds : [],
      bookIds: contentTitle === "Book" ? dataIds : [],
      neighborhoodIds: contentTitle === "Neighborhood" ? dataIds : [],
      ministryIds: contentTitle === "Ministries" ? dataIds : [],
      embassyIds: contentTitle === "Embassy" ? dataIds : [],
      companyIds: contentTitle === "Companies" ? dataIds : [],
      gettingAroundIds: contentTitle === "Getting Around" ? dataIds : [],
      artIds: contentTitle === "Art" ? dataIds : [],
      movieIds: contentTitle === "Movies" ? dataIds : [],
      danceIds: contentTitle === "Dance" ? dataIds : [],
      cinemaIds: contentTitle === "Cinema" ? dataIds : [],
      newsIds: contentTitle === "News" ? dataIds : [],
      theaterIds: contentTitle === "Theater" ? dataIds : [],
      tipsAndAdviceIds: contentTitle === "Tips And Advice" ? dataIds : [],
      thingsToDoIds: contentTitle === "Things To Do" ? dataIds : [],
      BestOfAfricaIds: contentTitle === "Best Of Africa" ? dataIds : [],
    };

    const response = await sendNotification(data);

    if (response?.status === 200) {
      setLoading(false);
      setShowModal(false);
    } else {
      setLoading(false);
    }
  };

  const hasData = Array.isArray(newsletterList) && newsletterList.length > 0;

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      {showModal ? (
        <NewsletterModal
          loading={loading}
          dataIds={dataIds}
          contentTitle={contentTitle}
          setDataIds={setDataIds}
          onSubmit={sendDailyDigest}
          setContentTitle={setContentTitle}
          onClose={() => {
            setShowModal(false);
            setLoading(false);
          }}
        />
      ) : null}

      <div className="mx-auto w-full max-w-7xl">
        {/* Header card */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Newsletter Subscribers
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Send daily digests and manage your subscriber list.
              </p>
            </div>
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Subscribers: {hasData ? newsletterList.length : 0}
              </span>
              <MyActionButton
                loading={loading}
                title="Select Daily Digest"
                onClick={() => setShowModal(true)}
                className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold shadow-sm transition hover:bg-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-500"
              />
            </div>
          </div>
        </div>

        {/* Search */}
        <div className="mb-4">
          <Search
            props={{
              title: "Email Address",
              onChange: (e) => SearchList(e),
            }}
          />
          <p className="mt-2 text-[11px] text-gray-500">
            Note: Latest content will be sent to subscribers.
          </p>
        </div>

        {/* Table */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Email Address ({count})
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Date Joined
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Time Joined
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {newsletter && newsletterList?.length > 0 ? (
                  newsletterList?.map((_newsletter_) => {
                    return (
                      <tr
                        key={_newsletter_?.newsletter_id}
                        className="transition-colors hover:bg-gray-50"
                      >
                        <td className="px-4 py-4 text-gray-900 break-words">
                          {_newsletter_?.email}
                        </td>
                        <td className="px-4 py-4 text-gray-700 whitespace-nowrap">
                          {new Date(_newsletter_?.createdAt).toDateString()}
                        </td>
                        <td className="px-4 py-4 text-gray-700 whitespace-nowrap">
                          {new Date(_newsletter_?.createdAt).toTimeString()}
                        </td>
                      </tr>
                    );
                  })
                ) : newsletter ? (
                  <tr>
                    <td
                      className="px-4 py-8 text-center text-sm text-gray-500"
                      colSpan={3}
                    >
                      No subscribers yet.
                    </td>
                  </tr>
                ) : (
                  Array.from({ length: 4 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-4">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-4">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-4">
                        <div className="h-4 w-32 rounded bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchNewsletter(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Overview;
